import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { SERVICE_URL } from '../../constants/url.constants';

export const headerInterceptor: HttpInterceptorFn = (req, next) => {
    const headers: Record<string, string> = {
        'x-kcv': 'identity',
    };

    if (req.url.includes(SERVICE_URL.KEY_CLOAK)) {
        headers['Ocp-Apim-Subscription-Key'] = environment.keyCloakSubscriptionKey;
    }

    if (req.url.includes(SERVICE_URL.PROFILE_PE)) {
        headers['Ocp-Apim-Subscription-Key'] = environment.sheLeapsPESubscriptionKey;
    }

    if (req.url.includes(SERVICE_URL.PROFILE_PG)) {
        headers['Ocp-Apim-Subscription-Key'] = environment.sheLeapsPGSubscriptionKey;
    }

    if (req.url.includes(SERVICE_URL.API_SETU)) {
        headers['X-APISETU-CLIENTID'] = environment.apiSetu.clientId;
        headers['X-APISETU-APIKEY'] = environment.apiSetu.key;
    }

    if (
        req.url.includes(SERVICE_URL.PIMS) ||
        req.url.includes(environment.imageBaseUrl) ||
        req.url.includes('api/vault')
    ) {
        headers['Ocp-Apim-Subscription-Key'] = environment.pimsSubscriptionKey;
    }

    if (req.url.includes(SERVICE_URL.SARAS_MELA_NOMINATION)) {
        headers['Ocp-Apim-Subscription-Key'] = environment.sarasMelaSubscriptionKey;
    }
    return next(req.clone({ setHeaders: headers }));
};
